import { useGlobals } from "@/hooks";
import { useClient } from "@/hooks";
import { useCorporateFlags } from "@/hooks";
import { useMemo } from "react";
import { findLojaForBrandPair } from "@/shared";

export const usePayments = () => {
  const { paymentCode } = useGlobals();
  const { selectedClient } = useClient();
  const { selectedBrandPair } = useCorporateFlags();

  const clientPayments = useMemo(() => {
    const matchedLoja = findLojaForBrandPair(selectedClient, selectedBrandPair);
    const pay = matchedLoja?.COD_PAGAMENTO;
    if (Array.isArray(pay) && pay.length > 0) {
      return [...pay].sort((a, b) => a.cod_condicao - b.cod_condicao);
    }

    return [];
  }, [selectedBrandPair, selectedClient]);

  const currentPayment = useMemo(() => {
    return clientPayments?.find(({ cod_condicao }) => cod_condicao === paymentCode)?.desc_condicao;
  }, [clientPayments, paymentCode]);

  return {
    clientPayments,
    currentPayment,
  };
};
